<template>
  <div id="app" class="inclusionCurriculum">
    <nav-component></nav-component>
    <hero-component></hero-component>
    <intro-component :IntroComponent="IntroComponent"></intro-component>
    <course-info-component></course-info-component>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavComponent from "../components/NavComponent.vue";
import HeroComponent from "../components/HeroComponent.vue";
import FooterComponent from "../components/FooterComponent.vue";
import IntroComponent from "../components/introComponent.vue";
import CourseInfoComponent from "../components/courseInfoComponent.vue";

export default {
  name: "app",
  components: {
    NavComponent,
    HeroComponent,
    FooterComponent,
    IntroComponent,
    CourseInfoComponent
  },
  metaInfo() {
        return {
            meta: [{ rel: 'canonical', href: 'https://starbuckscoffeeacademy.com/'},]
        }
    },
  data() {
    return {
      currentStep: 0,
      IntroComponent: {
        intoHeader: "CULTIVATE YOUR COFFEE CURIOSITY",
        intoHeaderMobile: "CULTIVATE YOUR COFFEE CURIOSITY",
        introContent:
          "There is always more to learn about the vast and wonderful world of coffee. The Starbucks Coffee Academy is designed to explore the many facets of the coffee industry and Starbucks role as a leader in ethical sourcing, roasting, blending, brewing and craft. We have built this education platform for you to learn more about the topics that interest you most. At Starbucks, we are enamored by coffee daily, and we hope you will be too."
      }
    };
  },
  created() {
    console.log("STORE ACCESS= ", this.$store.state.currentStep);
  }
};
</script>
